import { render, staticRenderFns } from "./CargoOrder.vue?vue&type=template&id=3246a77a&scoped=true&"
import script from "./CargoOrder.vue?vue&type=script&lang=js&"
export * from "./CargoOrder.vue?vue&type=script&lang=js&"
import style0 from "./CargoOrder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CargoOrder.vue?vue&type=style&index=1&id=3246a77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3246a77a",
  null
  
)

export default component.exports